import { Outlet } from "react-router-dom"

const AdminStudyPackagesScreen = () => {
  return (
    <>
      <Outlet />
    </>
  )
}

export default AdminStudyPackagesScreen
